// extracted by mini-css-extract-plugin
module.exports = {"container":"embedded-video_container__iMidb","wrapper":"embedded-video_wrapper__1Vtfa"};